/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import React from 'react'
import { Section, getState, format, showModal, fmt, matIcon, iconLabel } from '../twd'
import { useBondDetail, hasCreditRatings } from './use-bond-detail'
import { sectionCss } from './style'

const state = getState('bond_detail.credit_ratings', {
    show: true
})

export default () => {
    const [showSection, setShowSection_] = React.useState(state.value.show)
    const setShowSection = React.useCallback((m) => {
        state.set({show:m})
        setShowSection_(m)
    }, [])

    const {issue, events} = useBondDetail()
    if (!hasCreditRatings(issue)) return null

    let hasMoody = issue.moodyRating!=='-' && issue.mratingValue>0
    let hasMoodyNR = issue.moodyRating==='NR'
    let hasSp = issue.spRating!=='-' && issue.sratingValue>0
    let hasSpNR = issue.spRating==='NR'

    return <React.Fragment>
    <div className="xs-hide vertical-offset-sm"></div>
    <div data-name='bond-detail-credit-ratings'
        className="container"
        css={sectionCss}>

        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-xs-12">
            <Section
                title="Credit ratings"
                show={showSection}
                setShow={setShowSection}
                cls="small-header"
                arrowSize="large"
            >
            <div className="vertical-offset-sm text-muted">
                <div className="text-body text-bold">Long term Moody's rating</div>
                {hasMoody
                ? <span className="medium-header" dangerouslySetInnerHTML={{__html:issue.moodyRating || ''}} />
                : fmt.empty()}

                &nbsp; {
                    (!hasMoody || hasMoodyNR) ? ''
                    : issue.mratingValue>58 ? '(Investment grade)'
                    : '(High Yield)'
                }
                <br/>
                { hasMoody && <React.Fragment>
                    Effective {format.mdy(issue.mmaturityLtRatingDate)}
                    </React.Fragment>}
            </div>

            <div className="vertical-offset-sm text-muted">
                <div className="text-body text-bold">Long term S&amp;P rating</div>
                {hasSp
                ? <span className="medium-header" dangerouslySetInnerHTML={{__html:issue.spRating || ''}} />
                : fmt.empty()}
                &nbsp; {
                    (!hasSp || hasSpNR) ? ''
                    : issue.sratingValue>58 ? '(Investment grade)'
                    : '(High Yield)'
                }
                <br/>
                { hasSp && <React.Fragment>
                    Effective {format.mdy(issue.maturityLtRatingDate)}
                    </React.Fragment>}
            </div>

            {issue.type==='T' && <div className="vertical-offset-sm text-muted">
            United States Treasury securities are backed by the full faith and credit of the United States Government.
            </div>}

            <div className="vertical-offset-sm">
                <button
                className="link-button"
                onClick={(e) => {
                    showModal({
                        view: 'events',
                        tab: 'credit-ratings-actions',
                        issue,
                        events,
                        from: 'bond-detail',
                        source: e.target,
                    })
                }}>{iconLabel(matIcon('graphic_eq'), 'View full rating history')}
                </button>
            </div>

            </Section>
        </div></div>

        <div className="xs-show row vertical-offset-sm"></div>

    </div>

    </React.Fragment>
}
